<template>
  <div>
    <div class="container">
      <div class="grid-template-frontend">
        <div
          v-for="(col, index) in widgetSettings.layoutSettings"
          :key="index"
          class="row"
        >
          <template v-if="col === 1">
            <div class="col-xs-12 col-sm-12">
              <div
                v-if="getCardItem(col, index, 1) != null"
                class="card-item"
              >
                <card-item
                  :card-content="getCardItem(col, index, 1)"
                  :filestore="filestore"
                  grid-size="full"
                />
              </div>
            </div>
          </template>

          <template v-if="col === 1.2">
            <div class="col-xs-12 col-sm-12 col-md-4">
              <div
                v-if="getCardItem(col, index, 1) != null"
                class="card-item"
              >
                <card-item
                  :card-content="getCardItem(col, index, 1)"
                  :filestore="filestore"
                  grid-size="one-third"
                />
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-8">
              <div
                v-if="getCardItem(col, index, 2) != null"
                class="card-item"
              >
                <card-item
                  :card-content="getCardItem(col, index, 2)"
                  :filestore="filestore"
                  grid-size="two-third"
                />
              </div>
            </div>
          </template>

          <template v-if="col === 2">
            <template v-for="iter in col">
              <div
                :key="iter"
                class="col-xs-12 col-sm-12 col-md-6"
              >
                <div
                  v-if="getCardItem(col, index, iter) != null"
                  class="card-item"
                >
                  <card-item
                    :card-content="getCardItem(col, index, iter)"
                    :filestore="filestore"
                    grid-size="one-half"
                  />
                </div>
              </div>
            </template>

          </template>

          <template v-if="col === 2.1">
            <div class="col-xs-12 col-sm-12 col-md-8">

              <div
                v-if="getCardItem(col, index, 2) != null"
                class="card-item"
              >
                <card-item
                  :card-content="getCardItem(col, index, 1)"
                  :filestore="filestore"
                  grid-size="two-third"
                />
              </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-4">

              <div
                v-if="getCardItem(col, index, 2) != null"
                class="card-item"
              >
                <card-item
                  :card-content="getCardItem(col, index, 2)"
                  :filestore="filestore"
                  grid-size="one-third"
                />
              </div>
            </div>
          </template>

          <template v-if="col === 3">
            <template v-for="iter in col">
              <div
                :key="iter"
                class="col-xs-12 col-sm-12 col-md-4"
              >
                <div
                  v-if="getCardItem(col, index, iter) != null"
                  class="card-item"
                >
                  <card-item
                    :card-content="getCardItem(col, index, iter)"
                    :filestore="filestore"
                    grid-size="one-third"
                  />
                </div>
              </div>
            </template>
          </template>

        </div>
        <!-- End v-for -->
      </div>
      <!-- End grid-template -->
    </div>
  </div>
</template>

<script>
import cardItem from '../layouts/cards/card-content-grid.vue';
export default {
  components: {
    'card-item': cardItem
  },
  props: {
    widget: {
      type: Object,
      required: true,
      default: () => ({})
    },
    filestore: {
      type: [Object, String],
      required: true
    }
  },
  computed: {
    widgetSettings: function() {
      return this.widget.widgetSettings;
    }
  },
  methods: {
    getCardItem(col, index, id) {
      let card = null;
      const identifier = `element_${col}${index}${id}`;
      card = this.searchArray("gridId", identifier, this.widget.cardItems);
      if (card != null) {
        return card;
      }
    },
    searchArray: function(key, value, array, getArrayId = false) {
      for (let i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          if (getArrayId) {
            return i;
          } else {
            return array[i];
          }
        }
      }
    }
  }
};
</script>

<style lang="scss">
.grid-template-frontend .row [class*="col-"] {
  //margin-bottom: 2em;
}

.grid-template-frontend .row .card-item,
.grid-template-frontend .row .card-item > div {
  height: 100%;
  display: flex;
  width: 100%;
}
</style>
